/*
 * File: /src/router/routes/interests.js
 * Created Date: Monday May 31st 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 31st May 2021 9:21:20 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

const InterestsList = () =>
  import(
    /* webpackChunkName: "Interests" */ 'src/components/Dashboard/Views/Contacts/Interests/InterestsList.vue'
  );

export const interestsRoutes = [
  {
    path: 'contacts/interests',
    name: 'Interests',
    component: InterestsList
  }
];
